<form class="user-search" >
    <mat-icon>search</mat-icon>
    <mat-form-field class="user-search-input">

        <input matInput placeholder="Search car by name..." [(ngModel)]="search" name="search"
            (keyup)="applyFilter($event)">
    </mat-form-field>
</form>

<mat-divider></mat-divider>

<mat-card class="m-2 p-0">



    <div class="table-wrapper">

        <table mat-table [dataSource]="dataSource" matSort class="w-100">

            <!-- FullName Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> N° </th>
                <td mat-cell *matCellDef="let car">{{car.id}} </td>
            </ng-container>
            <ng-container matColumnDef="marque">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Marque </th>
                <td mat-cell *matCellDef="let car">{{car.mark_lib}} </td>
            </ng-container>
            <ng-container matColumnDef="model">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Modele </th>
                <td mat-cell *matCellDef="let car">{{car.mod_lib}} </td>
            </ng-container>
            <ng-container matColumnDef="prix">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Prix de location </th>
                <td mat-cell *matCellDef="let car">{{car.vehicle_price_location}} </td>
            </ng-container>

            <!-- Username Column -->
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date d'enregistrement </th>
                <td mat-cell *matCellDef="let car">{{car.created_at}} </td>
            </ng-container>


            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let car">
                    <mat-form-field appearance="outline" class="p-0 m-0">
                        <mat-label> {{car.status}}</mat-label>
                        <mat-select  (selectionChange)="onStatusSelectionChange($event  ,car.id)" [disabled]="car.status.id == 1">
                            <mat-option >---</mat-option>
                            <mat-option *ngFor="let status of statuses" [value]="status">
                                {{status.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </ng-container>

            <ng-container matColumnDef="verification">
                <th mat-header-cell *matHeaderCellDef> Verification </th>
                <td mat-cell  *matCellDef="let cars "  >
                    
                    <mat-option  class="user-social"  >
                        <mat-slide-toggle color="primary" [(ngModel)]="cars.verification" (change)="onChange($event, cars.id,cars.status) " > </mat-slide-toggle>
                    </mat-option >
                   
                </td>
            </ng-container>

            <ng-container>

            </ng-container>
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>

                <td mat-cell *matCellDef="let car">

                    <button mat-icon-button color="warn" (click)="remove(car.id )" matTooltip="Remove">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let car; columns: displayedColumns;"></tr>
        </table>
        <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">No data available</p>
    </div>
    <mat-paginator showFirstLastButtons [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
</mat-card>